/*  MUI  */
import { Box, Button } from '@mui/material';
import { Close } from 'application/Shared/Icons';

/* React */
import React from 'react';

export const CloseButton = ({ ariaLabel, onClose, size = '16px' }) => (
    <Box position="absolute" right="5px" top="16px">
        <Button
            aria-label={ariaLabel}
            onClick={() => onClose()}
            type="button"
            variant="iconWithoutBorder"
        >
            <Close
                height={size}
                width={size}
                style={{ height: size, margin: '0', width: size }}
            />
        </Button>
    </Box>
);
